import React, { useState } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import { Col, Grid, Row } from 'react-bootstrap'
import { CONTRACT_TYPE_TO_NAME_MAP } from '../../../../../../../../shared/constants'
import StatusLabel from '../StatusLabel'
import { styles } from './styles'
import AddendumList from '../AddendumList'
import ArrowBottomIcon from '../../../../../../../../Assets/Images/icons/arrowBottom'
import GenericFlatButton from '../../../../../../../../Components/GenericFlatButton'

const ArchivedContractItem = ({
  classes,
  onContractNameClick,
  ambassador,
  contract: contractGroup,
  generateContractName,
  index,
  onCancelAddendum,
  generateAddendumName,
  onAddAddendum,
}) => {
  const [openAddendum, setOpenAddendum] = useState(false)
  const { contract, addendums } = contractGroup

  const renderHeader = () => {
    return (
      <Row>
        <Col xs={3}>
          <p className={classes.columnHeader} style={{ marginLeft: 20 }}>
            Contract
          </p>
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Status</p>
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Contract type</p>
        </Col>
        <Col xs={1}>
          <p className={classes.columnHeader}>Hours</p>
        </Col>

        <Col xs={1}>
          <p className={classes.columnHeader}>Start date</p>
        </Col>
        <Col xs={1}>
          <p className={classes.columnHeader}>End date</p>
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Sent by</p>
        </Col>
      </Row>
    )
  }

  return (
    <Grid fluid className={classes.row}>
      {index == 0 && renderHeader()}
      <Row style={{ marginTop: 14 }}>
        <Col xs={3}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                transform: openAddendum ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
              className={classes.arrowButton}
              onClick={() => setOpenAddendum(!openAddendum)}
            >
              <ArrowBottomIcon />
            </div>
            <div
              className={classes.link}
              onClick={() => onContractNameClick(contract)}
            >
              {generateContractName(contract)}
            </div>
          </div>
        </Col>
        <Col xs={2}>
          <StatusLabel data={contract} />
        </Col>
        <Col xs={2}>
          <p className={classes.columnValue}>
            {CONTRACT_TYPE_TO_NAME_MAP[contract.templateDocument.name]}
          </p>
        </Col>
        <Col xs={1}>
          <p className={classes.columnValue}>
            {contract.metadata ? contract.metadata.fields.hoursPerWeek : '-'}
          </p>
        </Col>

        <Col xs={1}>
          <p className={classes.columnValue}>
            {contract.startAt
              ? moment(contract.startAt).format('DD.MM.YYYY')
              : '-'}
          </p>
        </Col>
        <Col xs={1}>
          <p className={classes.columnValue}>
            {contract.endAt ? moment(contract.endAt).format('DD.MM.YYYY') : '-'}
          </p>
        </Col>

        <Col xs={2}>
          <p
            className={classes.userLink}
            onClick={() => {
              window.open(
                `/dashboard/users/${
                  contract.metadata ? contract.metadata.sender.id : null
                }`,
                '_blank',
              )
            }}
          >
            {contract.metadata ? contract.metadata.sender.name : '-'}
          </p>
        </Col>
      </Row>
      {openAddendum && addendums && addendums.length > 0 && (
        <AddendumList
          isOpen={openAddendum}
          addendums={addendums}
          onContractNameClick={onContractNameClick}
          onCancelAddendum={onCancelAddendum}
          generateAddendumName={generateAddendumName}
          contract={contract}
          ambassador={ambassador}
        />
      )}
      <GenericFlatButton
        type={'text'}
        title={'+ Create addendum'}
        onClick={() =>
          onAddAddendum({ contract, isDatesInRangeContract: true })
        }
        customStyles={classes.addAddendumButton}
      />
    </Grid>
  )
}

export default injectStyles(styles)(ArchivedContractItem)
